<p-dialog [(visible)]="isVisible" [modal]="true" [closable]="true" [header]="title" [responsive]="true" [style]="{ width: '25rem' }">
  <form [formGroup]="form">
    <!-- 申請退回 - 標準提示 -->
    <span class="p-text-secondary block mb-3" *ngIf="!showRadio && !showInput">請問是否需要申請退回？</span>
    
    <!-- 申請退回 - 需要輸入原因 -->
    <span class="p-text-secondary block mb-3" *ngIf="!showRadio && showInput">請輸入退回原因：</span>
    
    <!-- 回覆退回申請 - 選擇同意/拒絕 -->
    <span class="p-text-secondary block mb-3" *ngIf="showRadio">請問是否同意文件退回申請：</span>
    
    <!-- 同意/拒絕選項 (用於回覆) -->
    <div class="flex flex-column gap-2" *ngIf="showRadio">
      <div class="flex align-items-center gap-2">
        <p-radioButton name="decision" value="accept" formControlName="decision"></p-radioButton>
        <label>同意</label>
      </div>
      <div class="flex align-items-center gap-2">
        <p-radioButton name="decision" value="reject" formControlName="decision"></p-radioButton>
        <label>拒絕</label>
      </div>
    </div>

    <!-- 原因輸入框 -->
    <div class="flex flex-column gap-2 mt-3" *ngIf="showInput || (showRadio && form.get('decision')?.value === 'reject')">
      <input pInputText id="reason" formControlName="reason" class="w-full" />
    </div>

    <!-- 按鈕區域 -->
    <p-footer class="flex w-full justify-end mt-4">
      <div class="flex gap-2">
        <p-button label="取消" icon="pi pi-times" severity="secondary" (click)="cancel()"></p-button>
        <p-button 
          label="確認" 
          icon="pi pi-check" 
          class="p-button-primary" 
          [disabled]="(showInput && !form.get('reason')?.value) || 
                    (showRadio && form.get('decision')?.value === 'reject' && !form.get('reason')?.value)" 
          (click)="confirm()"></p-button>
      </div>
    </p-footer>
  </form>
</p-dialog>